import { RefreshCw, Briefcase, Link2 } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import {
  FilterBar,
  FilterSearch,
  FilterSelect,
  PageToolbar,
  SegmentTabs,
  ToolbarControlsGroup,
  ToolbarIconButton,
} from '@/components/ui/page-toolbar'
import type { PjAgradaFilter } from '@/hooks/usePjAgradaPage'

type Props = {
  filter: PjAgradaFilter
  setFilter: (v: PjAgradaFilter) => void
  search: string
  setSearch: (v: string) => void
  loading: boolean
  onReload: () => void
  canWrite: boolean
  onNew: () => void
  onInvite?: () => void
}

export function PjAgradaTopbar({
  filter,
  setFilter,
  search,
  setSearch,
  loading,
  onReload,
  canWrite,
  onNew,
  onInvite,
}: Props) {
  return (
    <PageToolbar
      navigation={
        <SegmentTabs
          value='lista'
          onChange={() => undefined}
          tabs={[{ id: 'lista', label: 'Colaboradores PJ', icon: Briefcase }]}
          ariaLabel='Funcionários PJ Agrada'
        />
      }
      controls={
        <ToolbarControlsGroup>
          {canWrite && onInvite && (
            <Button
              type='button'
              variant='secondary'
              size='sm'
              onClick={onInvite}
              icon={<Link2 size={14} />}
            >
              Link de cadastro
            </Button>
          )}
          {canWrite && (
            <Button type='button' variant='primary' size='sm' onClick={onNew}>
              Novo funcionário
            </Button>
          )}
          <ToolbarIconButton
            active={loading}
            onClick={onReload}
            title='Atualizar'
            aria-label='Atualizar'
          >
            <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
          </ToolbarIconButton>
        </ToolbarControlsGroup>
      }
      filters={
        <FilterBar>
          <FilterSearch
            value={search}
            onChange={setSearch}
            placeholder='Buscar por nome, CPF, CNPJ, e-mail ou cargo…'
          />
          <FilterSelect
            value={filter}
            onChange={(v) => setFilter(v as PjAgradaFilter)}
            ariaLabel='Filtrar funcionários'
          >
            <option value='todos'>Todos</option>
            <option value='NAO_PREENCHIDO'>Não preenchido</option>
            <option value='NAO_CONCLUIDO'>Não concluído</option>
            <option value='ATIVO'>Ativos</option>
            <option value='INATIVO'>Inativos</option>
          </FilterSelect>
        </FilterBar>
      }
    />
  )
}
